import { render, staticRenderFns } from "./ExpandableItem.vue?vue&type=template&id=21fc3b6c&scoped=true"
import script from "./ExpandableItem.vue?vue&type=script&lang=js"
export * from "./ExpandableItem.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItem.vue?vue&type=style&index=0&id=21fc3b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc3b6c",
  null
  
)

export default component.exports